module.exports = __webpack_public_path__ + "assets/img/school.ab86d927.png";